import { FormStore, GlobalStore } from '@roc/feature-app-core';

const form = {
  fields: {
    unitNumber: {
      value: '',
      error: null,
      rule: '',
      label: 'Unit',
    },
    tenantName: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['vacant', false] }],
      message: 'Tenant Name is required.',
      label: 'Tenant Name',
    },
    leaseType: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['vacant', false] }],
      message: 'Lease Type is required.',
      label: 'Lease Type',
    },
    startDate: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['vacant', false] }],
      message: 'Start Date is required.',
      label: 'Start Date',
    },
    endDate: {
      value: '',
      error: null,
      rule: '',
      label: 'End Date',
    },
    monthlyRent: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['vacant', false] }],
      message: 'Monthly Rent is required.',
      label: 'Monthly Rent',
    },
    marketRent: {
      value: 0,
      error: null,
      rule: '',
      label: 'Market Rent',
    },
    vacant: {
      value: true,
      error: null,
      rule: '',
      label: 'Vacant',
    },
    sectionEightFourTwo: {
      value: '',
      error: null,
      rule: '',
      label: 'Section 8/42',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export const LEASE_TYPE_OPTIONS = [
  { label: 'Please Select', value: '' },
  { label: 'Term Lease', value: 'term_lease' },
  { label: 'Month-to-Month', value: 'month_to_month' },
];

export const LEASE_TYPE_LABELS: Record<string, string> = {
  term_lease: 'Term Lease',
  month_to_month: 'Month-to-Month',
};

export const VACANT_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const SECTION_842_OPTIONS = [
  { label: 'Please Select', value: '' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export class LeaseFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
  }
}
